var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4767_20518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 44C71 56.7025 60.7025 67 48 67C35.2975 67 25 56.7025 25 44C25 31.2975 35.2975 21 48 21C60.7025 21 71 31.2975 71 44ZM29.6 44C29.6 54.162 37.838 62.4 48 62.4C58.162 62.4 66.4 54.162 66.4 44C66.4 33.838 58.162 25.6 48 25.6C37.838 25.6 29.6 33.838 29.6 44Z",
    fill: "#30C48F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 44,
    r: 19,
    fill: "#30C48F",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 55C48.5302 55 49.0389 54.7893 49.414 54.4142C49.7891 54.0391 49.9998 53.5304 49.9998 53H45.9998C45.9998 53.5304 46.2105 54.0391 46.5856 54.4142C46.9606 54.7893 47.4694 55 47.9998 55ZM39.9998 51H55.9998C56.1975 51 56.3908 50.9413 56.5552 50.8314C56.7197 50.7215 56.8478 50.5654 56.9235 50.3827C56.9991 50.2 57.0189 49.9989 56.9804 49.805C56.9418 49.611 56.8466 49.4329 56.7068 49.293L54.9998 47.586V42C54.9966 40.3185 54.3887 38.6942 53.2871 37.4238C52.1856 36.1533 50.6639 35.3214 48.9998 35.08V34C48.9998 33.7348 48.8944 33.4804 48.7069 33.2929C48.5194 33.1054 48.265 33 47.9998 33C47.7346 33 47.4802 33.1054 47.2927 33.2929C47.1051 33.4804 46.9998 33.7348 46.9998 34V35.08C45.3357 35.3214 43.814 36.1533 42.7124 37.4238C41.6109 38.6942 41.003 40.3185 40.9998 42V47.586L39.2928 49.293C39.153 49.4329 39.0578 49.611 39.0192 49.805C38.9806 49.9989 39.0004 50.2 39.0761 50.3827C39.1518 50.5654 39.2799 50.7215 39.4443 50.8314C39.6087 50.9413 39.802 51 39.9998 51ZM42.7068 48.707C42.8943 48.5195 42.9997 48.2652 42.9998 48V42C42.9998 40.6739 43.5266 39.4021 44.4643 38.4645C45.4019 37.5268 46.6737 37 47.9998 37C49.3259 37 50.5976 37.5268 51.5353 38.4645C52.473 39.4021 52.9998 40.6739 52.9998 42V48C52.9998 48.2652 53.1052 48.5195 53.2928 48.707L53.5858 49H42.4138L42.7068 48.707Z",
    fill: "#FAFAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4767_20518",
    x: 0,
    y: 0.5,
    width: 95.5,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.92549 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4767_20518"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4767_20518",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootNotificationIcon);
export default __webpack_public_path__ + "static/media/bootNotificationIcon.47386d5469d7f160b72c0aff705cffb9.svg";
export { ForwardRef as ReactComponent };